import {
    documentMimeTypes,
    getDownloadName,
    imageMimeTypes,
    isDocumentType,
    isImageType,
    isPdfType,
} from "./attachmentMime";

// Re-export pour compatibilité des imports existants (`import { documentMimeTypes } from '.../EmailAttachement'`).
export { imageMimeTypes, documentMimeTypes };

type EmailAttachmentProps = {
    id: string;
    name: string;
    size: number;
    type: string;
    path: string;
    preview: string;
    createdAt: Date;
    modifiedAt: Date;
    sentAt?: Date;
    contentId?: string;
    isInline?: boolean;
    uniqueMailvistaId?: string;
};

export default class EmailAttachment {
    id: string;

    name: string;

    size: number;

    type: string;

    path: string;

    preview: string;

    createdAt: Date;

    modifiedAt: Date;

    sentAt?: Date;

    contentId?: string;

    /** PJ intégrée au corps (CID) : signature, message cité du fil… */
    isInline?: boolean;

    /** Identité de la copie du mail porteur. */
    uniqueMailvistaId?: string;

    constructor({
        id,
        name,
        size,
        type,
        path,
        preview,
        createdAt,
        modifiedAt,
        sentAt,
        contentId,
        isInline,
        uniqueMailvistaId,
    }: EmailAttachmentProps) {
        this.id = id;
        this.name = name;
        this.size = size;
        this.type = type;
        this.path = path;
        this.preview = preview;
        this.createdAt = createdAt;
        this.modifiedAt = modifiedAt;
        this.sentAt = sentAt;
        this.contentId = contentId;
        this.isInline = isInline;
        this.uniqueMailvistaId = uniqueMailvistaId;
    }

    isImage() {
        return isImageType(this.type);
    }

    isPdf() {
        return isPdfType(this.type);
    }

    isDocument() {
        return isDocumentType(this.type);
    }

    isEmbeddedInBody() {
        return this.isInline === true;
    }

    getDownloadName() {
        return getDownloadName(this.name, this.type);
    }
}
